import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTicketIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 94,
	height: 62,
	viewBox: "0 0 94 62",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00001 62C2.23866 62 0.000136954 59.7613 4.9831e-06 57L3.94495e-06 45.125C3.74145e-06 42.7972 1.70322 40.8744 3.61006 39.5392C6.29893 37.6565 8.05762 34.5345 8.05762 31C8.05754 27.4656 6.29886 24.3441 3.61007 22.4616C1.70318 21.1266 1.67885e-06 19.2038 1.47535e-06 16.8761L4.37114e-07 5.00001C0.00021026 2.23876 2.23871 8.02203e-06 5 7.78063e-06L89 4.37114e-07C91.7613 8.35762e-07 93.9998 2.23876 94 5L94 17.4364C94 19.7892 92.2638 21.7215 90.31 23.0323C87.6662 24.8059 85.9424 27.7129 85.9424 31C85.9424 34.2871 87.6662 37.1946 90.3099 38.9685C92.2638 40.2795 94 42.2118 94 44.5647L94 57C93.9999 59.7613 91.7613 62 89 62L5.00001 62Z",
			fill: "#00A8E1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.1086,
			y: 55.4661,
			width: 5,
			height: 5,
			rx: 2.5,
			transform: "rotate(180 27.1086 55.4661)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.1086,
			y: 44.4832,
			width: 5,
			height: 5,
			rx: 2.5,
			transform: "rotate(180 27.1086 44.4832)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.1086,
			y: 33.5002,
			width: 5,
			height: 5,
			rx: 2.5,
			transform: "rotate(180 27.1086 33.5002)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.1086,
			y: 22.5171,
			width: 5,
			height: 5,
			rx: 2.5,
			transform: "rotate(180 27.1086 22.5171)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.1086,
			y: 11.5342,
			width: 5,
			height: 5,
			rx: 2.5,
			transform: "rotate(180 27.1086 11.5342)",
			fill: "white"
		})
	]
});
export default SvgTicketIcon;
